import React from 'react'
import { usePackagesContext } from '../context/packages/PackagesProvider'
import { PACKAGES_ACTIONS } from '../context/packages/PACKAGES_ACTIONS'
import SponsorService from '../services/SponsorService'

export default function usePackagesActions() {
    const {packagesDispatch} = usePackagesContext()
    async function getPackages() {
        try {
            packagesDispatch({
                type: PACKAGES_ACTIONS.SET_IS_LOADING,
                payload: {
                    isLoading: true,
                },
            })
            const {data} = await SponsorService.getPackages()

            packagesDispatch({
                type: PACKAGES_ACTIONS.SET_PACKAGES,
                payload: {
                    packages: data.packages,
                },
            })
        } catch (error) {
            throw error
        } finally{
            packagesDispatch({
                type: PACKAGES_ACTIONS.SET_IS_LOADING,
                payload: {
                    isLoading: false,
                },
            })
        }
    }
    return {getPackages}
}
